import { createReducer } from '../utils/helpers';
import { ActionTypes } from '../utils/constants';

export const avaluoInitialState = {
  data: {},
  isLoading: false,
  isLoadingAvaluo: true,
  error: false,
  currentAvaluo: null,
  personalInfo: null
};

export default {
  avaluos: createReducer(avaluoInitialState, {
    [ActionTypes.FETCH_AVALUOS_REQUEST](state) {
      return {
        ...state,
        isLoading: true,
        error: false,
        currentAvaluo: null,
        isLoadingAvaluo: false,
        personalInfo: null,
      };
    },
    [ActionTypes.FETCH_AVALUOS_SUCCESS](state, action) {
      return {
        ...state,
        isLoading: false,
        data: action.payload.options,
      };
    },
    [ActionTypes.FETCH_AVALUOS_FAILURE](state, action) {
      return {
        ...state,
        isLoading: false,
      };
    },
    [ActionTypes.GET_AVALUO_REQUEST](state) {
      return {
        ...state,
        isLoadingAvaluo: true,
        currentAvaluo: null,
      };
    },
    [ActionTypes.GET_AVALUO_SUCCESS](state, action) {
      return {
        ...state,
        isLoadingAvaluo: false,
        currentAvaluo: action.payload,
      };
    },
    [ActionTypes.GET_AVALUO_FAILURE](state, action) {
      return {
        ...state,
        isLoadingAvaluo: false,
      };
    },
    [ActionTypes.SEND_AVALUO_REQUEST](state, action) {
      const { properties, personalInfo } = action.payload;
      return {
        ...state,
        personalInfo,
        currentAvaluo: {
          ...state.currentAvaluo,
          placa: properties.placa,
          estado: properties.estado
        }
      };
    },
  }),
};
